/* eslint-enable */
/* eslint-enable */

class AnimationExVideoPopup {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleExVideoPopup = this.sectionsContainer.querySelectorAll('.section-ex-video-popup');
		
		if (!this.$moduleExVideoPopup.length)
			return;
		
		this.$moduleExVideoPopupElements = [];

		this.$moduleExVideoPopup.forEach(module => {
			this.$moduleExVideoPopupElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleExVideoPopup.forEach((module, index) => {
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleExVideoPopupElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		this.moduleExVideoPopup = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleExVideoPopup[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleExVideoPopupElements[index], { clearProps: true });
			}
        });
    
        this.moduleExVideoPopup.addLabel('step1');
        this.moduleExVideoPopup.to(this.$moduleExVideoPopup[index], { opacity: 1, duration: 1 }, 'step1');
		this.moduleExVideoPopup.to(this.$moduleExVideoPopupElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}

export default AnimationExVideoPopup;
